import { Check } from "lucide-react";
import Reveal from "../Reveal";
import { COMPARE } from "../../data/content";

const Tick = () => <Check size={18} strokeWidth={2.5} className="text-gold mx-auto" aria-label="Included" />;
const Dash = () => <span className="text-stone/35 mx-auto block text-center" aria-label="Not included">—</span>;

export default function CompareTable() {
    return (
        <section id="compare" className="section-pad pt-0" data-testid="compare-section">
            <div className="container-luxe">
                <Reveal className="mb-12 max-w-2xl">
                    <p className="eyebrow mb-5">At a Glance</p>
                    <h2 className="font-serif text-navy text-3xl sm:text-4xl leading-snug">
                        Compare <span className="italic text-gold">&amp; begin</span>
                    </h2>
                </Reveal>

                {/* Desktop table */}
                <Reveal delay={0.1} className="hidden md:block">
                    <table className="w-full border-collapse bg-white border border-line" data-testid="compare-table">
                        <thead>
                            <tr className="bg-navy text-cream">
                                <th className="text-left font-serif font-normal text-base px-6 py-5">What&rsquo;s included</th>
                                {COMPARE.packages.map((p) => (
                                    <th key={p} className="font-serif font-normal text-base px-6 py-5 w-52">
                                        {p}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {COMPARE.rows.map((row, i) => (
                                <tr key={row.label} className={i % 2 === 0 ? "bg-cream/40" : "bg-white"}>
                                    <td className="px-6 py-4 text-sm font-light text-navy/90 border-t border-line">{row.label}</td>
                                    {row.avail.map((ok, j) => (
                                        <td
                                            key={j}
                                            className={`px-6 py-4 border-t border-line text-center ${j === 2 ? "bg-gold/5" : ""}`}
                                        >
                                            {ok ? <Tick /> : <Dash />}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Reveal>

                {/* Mobile cards */}
                <div className="md:hidden grid gap-6">
                    {COMPARE.packages.map((p, pi) => (
                        <Reveal key={p} delay={0.08 * pi}>
                            <div
                                data-testid="compare-table-mobile-card"
                                className="bg-white border border-line"
                            >
                                <div className="bg-navy text-cream px-5 py-4 flex items-center justify-between">
                                    <span className="font-serif text-lg">{p}</span>
                                    {pi === 1 && <span className="text-[10px] tracking-[0.18em] uppercase bg-gold text-navy px-2.5 py-1">Most Popular</span>}
                                    {pi === 2 && <span className="text-[10px] tracking-[0.18em] uppercase border border-gold/60 text-gold px-2.5 py-1">Ultimate</span>}
                                </div>
                                <ul className="p-5 space-y-3">
                                    {COMPARE.rows
                                        .filter((r) => r.avail[pi])
                                        .map((r) => (
                                            <li key={r.label} className="flex items-start gap-2.5 text-sm font-light text-navy/85">
                                                <Check size={15} strokeWidth={2.5} className="text-gold mt-0.5 shrink-0" />
                                                {r.label}
                                            </li>
                                        ))}
                                </ul>
                            </div>
                        </Reveal>
                    ))}
                    <p className="text-center text-xs text-stone/60 -mt-2">
                        Items not listed on a card are not part of that package.
                    </p>
                </div>
            </div>
        </section>
    );
}
